var style = {
  "Crosshair": "_Crosshair_1t1jt_1"
};

export { style as default };
